// @todo: Remove this file as this polyfill is now redundant

/* eslint-disable */
if (!Element.prototype.matches)
  Element.prototype.matches = (Element.prototype as any).msMatchesSelector || Element.prototype.webkitMatchesSelector;
